module.exports = __webpack_public_path__ + "static/media/arrow_right.fb6b4700.svg";